<template>
	<div class="clx-video">
		<titles :names="'onetu'"></titles>
		<!-- 主体 -->
		<div class="clx-home-main">
			<div class="clx-home-main-background"></div>
			<!-- 详情 -->
			<ul class="clx-home-main-content">
				<li class="clx-home-main-contentbox" v-for="(item,index) in listtudata" :key="index" @click="gotupian(item.url)">
					<span>{{item.tit}}</span>
					<img :src="item.imgs">
					<img src="../../../src/assets/jjydt/ytkd/21.png" :style="isbig ? 'margin:-62px 0 0 -205px;':'margin:-50px 0 0 -160px;'" style="position:absolute;z-index: 99;max-width: 20px;" v-if="index==20">
				</li>
			</ul>
		</div>

		<!-- <div class="onetushow" v-if="onetushow">
			<img :src="onetuimg" alt="">
			<span class="backbtn" @click="closeModel()">返 回</span>
		</div> -->
	</div>
</template>

<script>
	import goItem from '@/mixin/clx-goItem'
	import titles from '../../components/pagetitle/title'
	export default {
		name: "lawyer-c",
		components: {
			titles
		},
		mixins: [goItem],
		data() {
			return {
				keyword: '', //要搜索关键字
				onetushow: false, //视频弹窗隐藏
				onetuimg:'',
				isbig:false,
				listtudata:[
					{
						tit:'一图读懂①丨扎实稳定全省经济运行 河北发布“1+20”政策体系',
						imgs:require('../../assets/jjydt/ytkd/y- (1).png'),
						url:require('../../assets/jjydt/ytkd/y- (1).jpg')
					},
					{
						tit:'一图读懂②丨《扎实稳定全省经济运行一揽子政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (2).png'),
						url:require('../../assets/jjydt/ytkd/y- (2).jpg')
					},
					{
						tit:'一图读懂③丨《关于稳住经济的三十条财政政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (3).png'),
						url:require('../../assets/jjydt/ytkd/y- (3).jpg')
					},
					{
						tit:'一图读懂④丨《稳定经济十条货币金融政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (4).png'),
						url:require('../../assets/jjydt/ytkd/y- (4).jpg')
					},
					{
						tit:'一图读懂⑤丨《关于稳投资的六条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (5).png'),
						url:require('../../assets/jjydt/ytkd/y- (5).jpg')
					},
					{
						tit:'一图读懂⑥｜《关于促消费十四条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (6).png'),
						url:require('../../assets/jjydt/ytkd/y- (6).jpg')
					},
					{
						tit:'一图读懂⑦丨《关于稳住外贸外资基本盘的十六条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (7).png'),
						url:require('../../assets/jjydt/ytkd/y- (7).jpg')
					},
					{
						tit:'一图读懂⑧丨《关于保粮食能源安全的十五条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (8).png'),
						url:require('../../assets/jjydt/ytkd/y- (8).jpg')
					},
					{
						tit:'一图读懂⑨丨《关于保产业链供应链稳定的九条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (9).png'),
						url:require('../../assets/jjydt/ytkd/y- (9).jpg')
					},
					{
						tit:'一图读懂⑩丨《关于保基本民生的十条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (10).png'),
						url:require('../../assets/jjydt/ytkd/y- (10).jpg')
					},
					{
						tit:'一图读懂⑪丨《关于稳住全省工业经济大盘的五条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (11).png'),
						url:require('../../assets/jjydt/ytkd/y- (11).jpg')
					},
					{
						tit:'一图读懂⑫丨《关于扎实推进农业经济发展的十四条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (12).png'),
						url:require('../../assets/jjydt/ytkd/y- (12).jpg')
					},
					{
						tit:'一图读懂⑬丨《关于支持房地产业良性循环和健康发展的五条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (13).png'),
						url:require('../../assets/jjydt/ytkd/y- (13).jpg')
					},
					{
						tit:'一图读懂⑭丨《关于促进交通运输发展的六条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (14).png'),
						url:require('../../assets/jjydt/ytkd/y- (14).jpg')
					},
					{
						tit:'一图读懂⑮丨《关于促进文化产业和旅游业恢复发展的八条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (15).png'),
						url:require('../../assets/jjydt/ytkd/y- (15).jpg')
					},
					{
						tit:'一图读懂⑯丨《关于支持企业高质量发展十条用地政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (16).png'),
						url:require('../../assets/jjydt/ytkd/y- (16).jpg')
					},
					{
						tit:'一图读懂⑰丨《关于稳住经济的五条环保政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (17).png'),
						url:require('../../assets/jjydt/ytkd/y- (17).jpg')
					},
					{
						tit:'一图读懂⑱｜《关于科技支持全省经济平稳发展的十二条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (18).png'),
						url:require('../../assets/jjydt/ytkd/y- (18).jpg')
					},
					{
						tit:'一图读懂⑲｜《关于扶持企业上市的十一条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (19).png'),
						url:require('../../assets/jjydt/ytkd/y- (19).jpg')
					},
					{
						tit:'一图读懂⑳｜《关于进一步促进高校毕业生等青年就业创业的十九条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (20).png'),
						url:require('../../assets/jjydt/ytkd/y- (20).jpg')
					},
					{
						tit:'一图读懂\xa0\xa0\xa0\xa0｜《关于促进法治化营商环境建设的五条政策措施》解读',
						imgs:require('../../assets/jjydt/ytkd/y- (21).png'),
						url:require('../../assets/jjydt/ytkd/y- (21).jpg')
					},
				]
			}
		},

		methods: {
			onPlayerPause(player) {
				console.log(player)
			},
			// 关闭视频弹窗
			closeModel() {
				this.onetushow = false
			},
			toopenonetu(url){
				this.onetushow=true
				this.onetuimg=url
			},
			// 查询
			iSearch() {
				if (!this.keyword) {
					this.$clxTools.iMessage(this, 'e', '请输入内容后查询', 4)
					return
				}
				this.$router.push({
					name: 'result',
					params: {
						keyword: this.keyword
					}
				})
			},

		},
		created() {
			let keyword = this.$route.params.keyword
		},
		mounted() {
			if(window.screen.width>750){
				console.log("",window.screen.width)
				const html = document.querySelector('html');
				const width =window.screen.width
				html.style.fontSize = width/13 +'px'
				this.isbig=true
			}
		},
	};
</script>

<style lang="less">
	.clx-video {
		width: 7.5rem;
		padding: 0 0.24rem;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
		background: url(../../assets/clx-images/big-bg2.jpg) no-repeat center 0px;
		background-size: cover;

		// 主体
		.clx-home-main {
			// height: ~"calc(100vh -6rem)";
			// min-height: 5rem;
			height: 58%;
			position: relative;
			border-radius: 0.1rem;
			width: 100%;
			
			.clx-home-main-background {
				top: 0;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: #fff;
				border-radius: 0.2rem;
				border: 0.01rem solid #FFC35D;
				opacity: 0.4;
				z-index: 1;
			}
			// 内容
			.clx-home-main-content {
				// padding: 0.32rem 0.3rem;
				height: 100%;
				z-index: 2;
				position: absolute;
				overflow-x: hidden;
				overflow-y: auto;
				.clx-home-main-contentbox{
					position: relative;
					padding: 0.3rem 0;
					margin: 0 0.3rem;
					display: flex;
					flex-direction: row;
					justify-content: space-around;
					align-items: center;
					border-bottom: 0.02rem solid #D7D7D7;
					span{
						font-size: 0.34rem;
						color: #000;
						font-weight: 400;
						display: block;
						width:4.14rem;
						padding-right: 0.22rem;
					}
					img{
						max-width: 2.26rem;
					}
				}
				

				// 滚动条
				&::-webkit-scrollbar-track-piece {
					background-color: rgba(0, 0, 0, 0);
					border-left: 1px solid rgba(0, 0, 0, 0);
				}

				&::-webkit-scrollbar {
					width: 2px;
					height: 13px;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: rgba(0, 0, 0, 0.2);
					background-clip: padding-box;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
					min-height: 28px;
				}

				&::-webkit-scrollbar-thumb:hover {
					background-color: rgba(0, 0, 0, 0.2);
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}
			}
		}
		.onetushow{
			max-width: 7.5rem;
			position: fixed;
			z-index: 20;
			top: 0;
			margin: 0 auto;
			height: 100%;
			overflow-x: hidden;
			overflow-y: auto;
			// margin-left: -.24rem;
			img{
				width: 100%;
				margin: 0 auto;
			}
			.backbtn{
				position: fixed;
				z-index: 21;
				top: 0.4rem;
				// right: 0.3rem;
				margin-left: 5.5rem;
				display: block;
				padding: 0.1rem 0.4rem;
				border-radius: 0.3rem;
				background: linear-gradient(to bottom ,#D0E1AA,#45B3B2);
				display: flex;
				justify-content: center;
				align-items: center;
				color: #fff;
				font-weight: bold;
				font-size: 0.34rem;
			}
		}

	}
</style>
